import React from 'react';
import { Handshake, Sparkles, Camera } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { Reveal, Eyebrow } from './decor';

const Community = ({ onOpenAffiliate, onOpenCollaborators, onOpenGallery }) => {
  const { t } = useLanguage();

  const cards = [
    {
      key: 'affiliate',
      icon: <Handshake className="w-6 h-6" />,
      title: t('community.affiliateTitle'),
      desc: t('community.affiliateDesc'),
      topBorder: '#C9A84C',
      action: onOpenAffiliate
    },
    {
      key: 'collab',
      icon: <Sparkles className="w-6 h-6" />,
      title: t('community.collabTitle'),
      desc: t('community.collabDesc'),
      topBorder: '#C8282B',
      action: onOpenCollaborators
    },
    {
      key: 'gallery',
      icon: <Camera className="w-6 h-6" />,
      title: t('community.galleryTitle'),
      desc: t('community.galleryDesc'),
      topBorder: 'rgba(201,168,76,0.4)',
      action: onOpenGallery
    }
  ];

  return (
    <section id="community" style={{ background: 'radial-gradient(ellipse 70% 50% at 50% -8%, rgba(245,242,234,0.05), transparent 62%), #0A0A0A', padding: '100px 0' }} data-testid="community-section">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-[60px]">
        <Reveal>
          <div className="flex flex-col items-center text-center">
            <Eyebrow centered>{t('sections.communityEyebrow')}</Eyebrow>
            <h2 className="font-display mt-5" style={{ fontSize: 'clamp(34px, 5vw, 52px)', fontWeight: 700, color: '#F5F5F0' }}>
              {t('sections.communityTitle')}
            </h2>
            <p className="font-body mt-4" style={{ fontSize: '15px', fontWeight: 300, color: '#C2C1B6', maxWidth: '560px', lineHeight: 1.8 }}>
              {t('sections.communitySubtitle')}
            </p>
          </div>
        </Reveal>

        <div className="grid md:grid-cols-3 mt-14" style={{ gap: '2px' }}>
          {cards.map((c, i) => (
            <Reveal key={c.key} delay={0.1 * i} className="h-full">
              <button
                onClick={c.action}
                className="group h-full w-full text-left"
                style={{
                  background: '#1C1C1C',
                  borderTop: `3px solid ${c.topBorder}`,
                  padding: '52px 40px',
                  transition: 'transform 0.3s ease'
                }}
                onMouseEnter={(e) => (e.currentTarget.style.transform = 'translateY(-6px)')}
                onMouseLeave={(e) => (e.currentTarget.style.transform = 'translateY(0)')}
                data-testid={`community-card-${c.key}`}
              >
                <div
                  style={{
                    width: '48px',
                    height: '48px',
                    border: '1px solid rgba(201,168,76,0.18)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#C9A84C'
                  }}
                >
                  {c.icon}
                </div>
                <h3 className="font-display mt-6" style={{ fontSize: '22px', fontWeight: 700, color: '#F5F5F0' }}>
                  {c.title}
                </h3>
                <p className="font-body mt-3" style={{ fontSize: '14px', fontWeight: 300, color: '#C2C1B6', lineHeight: 1.8 }}>
                  {c.desc}
                </p>
                <span
                  className="font-body uppercase inline-flex items-center mt-7"
                  style={{ fontSize: '11px', letterSpacing: '2px', color: '#C9A84C', fontWeight: 600 }}
                >
                  {t('community.explore')}
                  <span className="ml-2 transition-transform duration-200 group-hover:translate-x-1">→</span>
                </span>
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Community;
